var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"external-link",style:({pointerEvents:!_vm.href?'none':'auto'}),attrs:{"target":"_blank","href":_vm.href}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('inline-svg',{attrs:{"src":require('@/assets/img/external_link_icon.svg')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }